
require("./../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import React from 'react';
import PageLoader from 'global/Loading/PageLoader';
import useProtectedRoute from 'hooks/useProtectedRoute';
import MainLayout from 'global/MainLayout';
import SEO from 'global/SEO';

import EbookFeature from 'features/ebook';
import QueryProvider from 'global/QueryProvider';

const Ebook = () => {
  const { isLoaded } = useProtectedRoute();
  return (
    <QueryProvider>
      <SEO title="Stockbit Ebook" />
      <MainLayout isFlexibleWidth>
        <PageLoader loaded={isLoaded} />
        <EbookFeature />
      </MainLayout>
    </QueryProvider>
  );
};

export default Ebook;
